import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UserDefinedFormField } from '@/components/UserDefinedForm/UserDefinedFormField';
import type { CmsEditableField } from '@/services/cms/userDefinedForm/CmsEditableField';
import type { CmsEditableFormStepFieldData } from '@/services/cms/userDefinedForm/CmsEditableFormStepFieldData';

export interface EditableFormStepProps extends CmsEditableFormStepFieldData {
    fields?: CmsEditableField[];
}

export function EditableFormStep(props: EditableFormStepProps) {
    return (
        <Box>
            {props.showTitle && props.title ? (
                <Typography component="h3" variant="h6">
                    {props.title}
                </Typography>
            ) : null}
            {props.fields?.map((field) => (
                <UserDefinedFormField field={field} key={field.name} />
            ))}
        </Box>
    );
}
